import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { Navbar } from "react-bootstrap";
import NavDropdown from "react-bootstrap/NavDropdown";
import "./components.css";
import AcvlLogo from "../images/Ukmover.png";
import { RiArrowRightSLine } from "react-icons/ri";
import strip from "../images/strip2.png";
import ACVllogofooter from "../images/ACVl-logo-footer.png";
import { BiSolidPhoneCall } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
//001E80

const Header2 = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [scroll, setScroll] = useState(false);

  const handleDropdownShow = () => {
    setShowDropdown(true);
  };

  const handleDropdownHide = () => {
    setTimeout(() => {
      setShowDropdown(false);
    }, 500);
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  });

  const [isSidenavOpen, setIsSidenavOpen] = useState(false);

  const openNav = () => {
    setIsSidenavOpen(true);
  };

  const closeNav = () => {
    setIsSidenavOpen(false);
  };

  return (
    <>
      <div>
        <header className={`headerMain ${scroll ? "sticky" : ""}`}>
          <Navbar
            className="servceNavbar"
            expand="lg"
            style={{
              backgroundColor: "#FFFFFF",
              backgroundColor: "transparent",
              backgroundImage:
                "linear-gradient(42deg, #f8f8f8 23%, rgb(37, 50, 55, 1) 0%)",
              height: "80px",
            }}
          >
            <Container>
              <a href="/">
                <img
                  src={AcvlLogo}
                  alt="ACVLlogo"
                  style={{ width: "100px" }}
                  className="logoinResponse"
                />
              </a>
              <Navbar.Toggle trols="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <>
                  {/* <div style={{ marginLeft: "20%", color: "#fff" }}>
                    <div className="d-flex align-items-center">
                      <a
                        href="tel:+1-365-336-1110"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        <div
                          className="hearts"
                          style={{
                            backgroundColor: "#D84214",
                            borderRadius: "50%",
                            border: "0px solid #000",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            marginLeft: "10px",
                            width: "50px",
                            height: "50px",
                            alignItems: "center",
                          }}
                        >
                          <BiSolidPhoneCall
                            style={{ color: "#ffff" }}
                            size={30}
                          />
                        </div>
                      </a>
                      <a
                        href="tel:+1-365-336-1110"
                        style={{ textDecoration: "none", color: "#ffff" }}
                      >
                        {" "}
                        <div style={{ marginLeft: "30px" }}>
                          <p
                            className="mb-1"
                            style={{
                              fontFamily: "Lato, sans-serif",
                              fontWeight: "700",
                            }}
                          >
                            Call us toll-free
                          </p>
                          <h3
                            style={{
                              fontSize: "x-large",
                              fontWeight: "700",
                              fontFamily: "Lato, sans-serif",
                              fontSize: "18px",
                            }}
                          >
                            +1-365-336-1110
                          </h3>
                        </div>
                      </a>
                    </div>
                  </div> */}
                  <div style={{ marginLeft: "10%", color: "#fff" }}>
                    <div className="d-flex align-items-center">
                      <a
                        // href="tel:+1-365-336-1110"
                         href="mailto : sales@gomovecanada.com"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        <div
                          className="hearts"
                          style={{
                            backgroundColor: "#D84214",
                            borderRadius: "50%",
                            border: "0px solid #000",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            marginLeft: "10px",
                            width: "50px",
                            height: "50px",
                            alignItems: "center",
                          }}
                        >
                          <MdEmail style={{ color: "#ffff" }} size={30} />
                        </div>
                      </a>
                      <a
                        // href="tel:+1-365-336-1110"
                         href="mailto : sales@gomovecanada.com"
                        style={{ textDecoration: "none", color: "#ffff" }}
                      >
                        {" "}
                        <div style={{ marginLeft: "30px" }}>
                          <p
                            className="mb-1"
                            style={{
                              fontFamily: "Lato, sans-serif",
                              fontWeight: "700",
                            }}
                          >
                            E-mail us
                          </p>
                          <h3
                            style={{
                              fontSize: "x-large",
                              fontWeight: "700",
                              fontFamily: "Lato, sans-serif",
                              fontSize: "18px",
                            }}
                          >
                            sales@gomovecanada.com
                          </h3>
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              </Navbar.Collapse>
            </Container>
          </Navbar>
          {/* Responsive */}
          <div className="servceNavbarResponsive">
            <header>
              <nav>
                <div id="navbar">
                  <div id="logo" className="reverse">
                    <div
                      className="mobile-btn"
                      style={{
                        fontSize: 45,
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                      onClick={openNav}
                    >
                      &#9776;
                    </div>
                    <a href="/" style={{ textAlign: "end" }}>
                      <img
                        src={AcvlLogo}
                        alt="ACVLlogo"
                        style={{ width: "100px", marginTop: "10px" }}
                      />
                    </a>
                  </div>
                </div>
              </nav>
              <div
                id="mySidenav"
                className="sidenav"
                style={{ width: isSidenavOpen ? "250px" : "0" }}
              >
                <a
                  href="/"
                  style={{ position: "absolute", top: "15px", left: "5px" }}
                >
                  <img
                    src={ACVllogofooter}
                    alt="ACVLlogo"
                    style={{ width: "100px" }}
                  />
                </a>
                <a
                  style={{ cursor: "pointer" }}
                  className="closebtn"
                  onClick={closeNav}
                >
                  &times;
                </a>
                <hr style={{ color: "#ffff" }} />
                <a href="#" style={{ color: "#ffff", fontSize: "25px" }}>
                  OUR SERVICE
                </a>
                <a href="/local-movers">Local Movers</a>
                <a href="/long-distance-movers">Long Distance Movers</a>
                <a href="/junk-removal">Junk Removal</a>
                <a href="/packaging-services">Packing Services</a>
                <a href="/moving-supplier">Moving Supplies</a>
                <a href="/storage-services">Storage Services</a>
                <hr style={{ color: "#ffff" }} />
                {/* <a href="/blogs" style={{color:'#ffff', fontSize: '25px', paddingTop:'30px'}}>OUR BLOG</a> */}
                <a
                  href="/Contact"
                  style={{
                    color: "#ffff",
                    fontSize: "25px",
                    paddingTop: "5px",
                  }}
                >
                  CONTACT US
                </a>
              </div>
            </header>
          </div>
          <div></div>
        </header>
      </div>
    </>
  );
};

export default Header2;
